import type {z} from "zod";
import {ListExpedientsQueryParams} from "@project/sdk/sales/zod";

export const listExpedientsSearchSchema = ListExpedientsQueryParams.extend({
  page: ListExpedientsQueryParams.shape.page.catch(1),
  perPage: ListExpedientsQueryParams.shape.perPage.catch(20),
  sortKey: ListExpedientsQueryParams.shape.sortKey.catch("name"),
  sortDir: ListExpedientsQueryParams.shape.sortDir.catch("asc"),
  q: ListExpedientsQueryParams.shape.q.catch(undefined),
  state: ListExpedientsQueryParams.shape.state.catch(undefined),
  countryCodes: ListExpedientsQueryParams.shape.countryCodes.catch(undefined),
  location: ListExpedientsQueryParams.shape.location.catch(undefined),
  customerId: ListExpedientsQueryParams.shape.customerId.catch(undefined),
  responsibleUserId: ListExpedientsQueryParams.shape.responsibleUserId.catch(undefined),
});
export type ListExpedientsSearchInput = z.input<typeof listExpedientsSearchSchema>;
export type ListExpedientsSearch = z.output<typeof listExpedientsSearchSchema>;
